export function useGetBpSessionId() {
  return document.querySelector('meta[name="bp-server-session-id"]')?.getAttribute('content') ?? '';
}
